<template>
  <fa @click="orderType()" :icon="['fas', icon]" class="d-inline cursor"></fa>
</template>

<script>
export default {
  name: "SortBy",
  props: {
    order_by: {
      type: String,
      default: "registration_date"
    }
  },
  inject: ['resetIcon'],
  watch: {
    resetIcon: {
      immediate: true,
      handler(newResetFunc) {
        if (typeof newResetFunc === 'function') {
          newResetFunc((triggeringId) => {
            if (this.order_by !== triggeringId) {
              this.reset();
            }
          });
        }
      },
    },
  },
  data(){
    return {
      icon: 'sort',
      order_type: 'asc',
      is_asc: false,
    }
  },
  methods: {
    orderType(){
      this.is_asc = !this.is_asc;
      this.order_type = this.is_asc ? 'asc' : 'desc';
      this.icon = this.is_asc ? 'chevron-up' : 'chevron-down';
      this.$emit('orderBy', {order_by: this.order_by, order_type: this.order_type});
    },
    reset(){
      this.icon = 'sort';
    }
  }
};
</script>
<style lang="scss" scoped>
  .cursor {
    cursor: pointer;
  }
</style>